<template>
    <div class="d-flex flex-row"
         @mouseover="hoverActive = true"
         @mouseleave="hoverActive = false">
        <input type="text"
               class="form-control"
               :class="[inputClasses]"
               autocomplete="false"
               :value="value"
               :placeholder="placeholderValue"
               :disabled="disabled"
               @keyup="emitNewValue($event.target.value)"
        >
        <div class="d-flex flex-column justify-content-center align-items-center"
             style="width: 50px; margin-left: -50px;"
        >
            <i v-show="hoverActive && value && value.length > 0" class="fas fa-times-circle text-danger cursor-pointer"
               @click="clearSearch"/>
            <i v-show="!hoverActive || !value || value.length === 0" class="fas fa-search"/>
        </div>
    </div>
</template>

<script>
import {debounce} from "@composables/debounce";

export default {
    props: {
        value: String,
        placeholder: String,
        disabled: Boolean,
        inputClasses: {
            types: [String, Object]
        },
    },

    data() {
        return {
            hoverActive: false
        }
    },

    methods: {
        clearSearch() {
            this.emitNewValue('')
        },

        emitNewValue: debounce(function (value) {
            this.$emit('input', value)
        }, 320)
    },

    computed: {
        placeholderValue() {
            return this.placeholder || __('actions.search');
        },
    }
}
</script>
